import { ProfileMenuDto } from 'src/app/core/data-models/resource.data-models';
import { ResourceDataService } from './../../../core/data-services/resource/resource-data.service';
import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
baseUrl='faq/';
menus:ProfileMenuDto[]=[];
constructor(
private resourceDataService:ResourceDataService,
public languageService:LanguageService,
){}

ngOnInit(): void {
  this.resourceDataService.GetProfileMenu().subscribe({
    next:(res)=>{
     this.menus= res;
    }
  })
}

}
